module.exports = __webpack_public_path__ + "img/FirstSouthern.64e74222.svg";